<alliance-carousel *ngIf="state.carouselOptions as carouselOptions" [options]="carouselOptions" class="santa-mt-10">
  <lib-slide-template [categoryData]="CategoriesDataValuesEnum.importVacancies">
    <p class="santa-typo-regular">{{ translations.content.importVacancies | translate }}</p>
  </lib-slide-template>
  <lib-slide-template [categoryData]="CategoriesDataValuesEnum.connectIntegration">
    <p class="santa-typo-regular">
      <span>{{ translations.content.connectIntegration.setup | translate }}</span>
      <a [routerLink]="['settings/integrations']" class="santa-text-red-500 santa-underline hover:santa-text-red-600">{{ translations.content.connectIntegration.sources | translate }}</a>
      <span>{{ translations.content.connectIntegration.toGetApplies | translate }}</span>
    </p>
  </lib-slide-template>
  <lib-slide-template [categoryData]="CategoriesDataValuesEnum.connectVacancies">
    <p class="santa-typo-regular">{{ translations.content.combineActiveVacancies | translate }}</p>
  </lib-slide-template>
  <lib-slide-template [categoryData]="CategoriesDataValuesEnum.setupRecruitment">
    <p class="santa-typo-regular">{{ translations.content.whileEditing | translate }}</p>
  </lib-slide-template>
</alliance-carousel>
